var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7762 0.501897C12.0514 0.746509 12.0762 1.16789 11.8316 1.44308L4.7205 9.44307C4.59398 9.58539 4.41265 9.66682 4.22222 9.66682C4.0318 9.66682 3.85046 9.58539 3.72395 9.44307L0.168401 5.44307C-0.076211 5.16788 -0.0514239 4.7465 0.223764 4.50189C0.498952 4.25728 0.920333 4.28207 1.16495 4.55725L4.22222 7.99669L10.8351 0.55726C11.0797 0.282072 11.501 0.257285 11.7762 0.501897Z",
    fill: "#FA9D49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCheck);
export default __webpack_public_path__ + "static/media/orange-check.d397921e39272b01ad8d995d645f4647.svg";
export { ForwardRef as ReactComponent };